import './MobileSelect.5a8c651b0f728ab2c8882f3ff85e41ab.css';
export default {"select":"_select_1hute_1"};